/** CoStar.Api.SuiteDetail.TenantSummary.LeaseDealRentType */
export var LeaseDealRentType;
(function (LeaseDealRentType) {
    LeaseDealRentType[LeaseDealRentType["None"] = 0] = "None";
    LeaseDealRentType[LeaseDealRentType["Asking"] = 1] = "Asking";
    LeaseDealRentType[LeaseDealRentType["Contract"] = 2] = "Contract";
    LeaseDealRentType[LeaseDealRentType["Effective"] = 3] = "Effective";
    LeaseDealRentType[LeaseDealRentType["NPVPerSFPeryr"] = 4] = "NPVPerSFPeryr";
    LeaseDealRentType[LeaseDealRentType["AnnuitizedNetEffectiveRent"] = 5] = "AnnuitizedNetEffectiveRent";
})(LeaseDealRentType || (LeaseDealRentType = {}));
